import { makeStyles } from '@rentacenter/racstrap';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { appConfig } from '../../config/app-config';
import { MicroFrontend } from './MicroFrontEnd';

export const paymentTestId = 'paymentTestId';

const useStyles = makeStyles(() => ({
  microAppContainer: {
    marginTop: '4rem',
  },
}));
export const Payment = ({ history }: RouteComponentProps) => {
  const classes = useStyles();
  return (
    <div className={classes.microAppContainer} data-testid={paymentTestId}>
      <MicroFrontend
        config={appConfig.microfrontends.payment}
        history={history}
      />
    </div>
  );
};
